import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { DropdownItem } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

export const TooltipValue = styled(Text)`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const OthersTooltipText = styled(Text)`
    white-space: break-spaces;
`;

export const StyledDropdownItem = styled(DropdownItem)`
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
`;
